import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from 'components/providers/PermissionProvider'
import { parkingLotNotificationsPermission } from 'utils'
import { ListSectionExpandButton } from 'components/views/parking-lot/elements/ListSection'
import ListSessionPayments from 'components/views/parking-lot/partials/ListSessionPayments'
import ListSessionNotifications from 'components/views/parking-lot/partials/ListSessionNotifications'

enum Section {
  Payments = 'payments',
  Notifications = 'notifications',
}

type Props = {
  session: {
    id: number,
    entry_at: string,
    exit_at?: string,
    modify?: boolean,
  }
}
type Functions = {}
type AllProps = Props & Functions

const ListSessionSections: FunctionComponent<AllProps> = ({ session }) => {
  if (!session) {
    return null
  }

  const { t } = useTranslation()
  const permissions = usePermissions()

  const [section, setSection] = useState<Section | null>(null)

  const showNotifications = parkingLotNotificationsPermission(permissions) && Boolean(session.exit_at)

  const handleExpand = (value: Section) => {
    setSection(section == value ? null : value)
  }

  return (
    <>
      <ListSectionExpandButton
        expand={section == Section.Payments}
        onClick={() => handleExpand(Section.Payments)}
      >{t('payments')}</ListSectionExpandButton>
      {showNotifications && (
        <ListSectionExpandButton
          expand={section == Section.Notifications}
          onClick={() => handleExpand(Section.Notifications)}
        >{t('notifications')}</ListSectionExpandButton>
      )}
      <ListSessionPayments session={session} expand={section == Section.Payments} />
      {showNotifications && (
        <ListSessionNotifications session={session} expand={section == Section.Notifications} />
      )}
    </>
  )
}

export default ListSessionSections
